import React, { useEffect, useState } from "react";
import { CsvBuilder } from 'filefy';
import { DataGrid, GridValueGetterParams } from '@mui/x-data-grid';
import { connect } from 'react-redux'
import * as LiftActions from '../../../store/lift/lift.actions'
import { Box, Button, CircularProgress, Grid, InputAdornment, TextField, Typography, Stack } from "@mui/material";
import SearchIcon from "../../../assets/searchIcon.svg";
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const LostScrapDetailsPage = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [tableData, setTableData] = useState(props.assetDetailsData?.items);
    const [pageSize, setPageSize] = useState(10);
    const customerId = props.selectedCustomerListData && props.selectedCustomerListData.customerId;
    const locationId = props.selectedCustomerListData && props.selectedLocationListData.locationId;

    const getLostScrapDetails = () => {
        const loggedInUserIDToken = localStorage.getItem("authToken");
        props.fetchAssetDetails(loggedInUserIDToken, customerId, locationId);
    }

    const runSearchQuery = (searchInput) => {
        const filteredData = props.assetDetailsData?.items.filter((item) => item.lostmins !== 0);
        const filteredLostScrapData = filteredData.filter((row) => {
            return (
                (row.rfid && row.rfid.toUpperCase().includes(searchInput.toUpperCase())) ||
                (row.customer_name && row.customer_name.toUpperCase().includes(searchInput.toUpperCase())) ||
                (row.location_name && row.location_name.toUpperCase().includes(searchInput.toUpperCase())) ||
                (row.store_name && row.store_name.toUpperCase().includes(searchInput.toUpperCase())) ||
                (row.store_address && row.store_address.toUpperCase().includes(searchInput.toUpperCase()))
            );
        });
        setTableData(filteredLostScrapData)
    };

    const handleChange = (value) => {
        props.updateSearchInput(value);
    }

    useEffect(() => {
        if (props?.assetDetailsData) {
            const data = props.assetDetailsData?.items;
            if (data?.length > 0) {
                const filteredData = props.assetDetailsData?.items.filter((item) => item.lostmins !== 0);
                setTableData(filteredData);
            }
            else {
                setTableData(props.assetDetailsData?.items);
            }
        }
    }, [props.assetDetailsData]);

    useEffect(() => {
        if (props.searchInput) {
            runSearchQuery(props.searchInput);
        } else if (props.assetDetailsData?.items) {
            const filteredData = props.assetDetailsData?.items.filter((item) => item.lostmins !== 0);
            setTableData(filteredData);
        }
    }, [props.searchInput, props.assetDetailsData?.items]);

    useEffect(() => {
        if (customerId && locationId) {
            getLostScrapDetails();
            props.updateSearchInput("");
        }
    }, [props.selectedCustomerListData, props.selectedLocationListData]);

    useEffect(() => {
        if (tableData) {
            setIsLoading(false)
        }
    }, [tableData])

    const columns = [
        {
            headerName: "RFID",
            field: "rfid",
            flex: 1.2
        },
        {
            headerName: "Lost Company",
            field: "customer_name",
            flex: 1
        },
        {
            headerName: "Lost Location",
            field: "location_name",
            flex: 1
        },
        {
            headerName: "Last Scan Time",
            field: "pallet_last_scanned",
            flex: 1
        },
        {
            headerName: "Store Location",
            field: "store_name",
            flex: 1
        },
        {
            headerName: "Store Address",
            field: "store_address",
            flex: 1,
            valueGetter: (params) =>
                `${params.row.store_address || "-"}`
        }
    ];

    const handleLostScrapDownload = () => {
        const currTs = Date.now();
        const data = tableData.map(rowData =>
            columns.map(columnDef => rowData[columnDef.field]),
        );
        const builder = new CsvBuilder(`lostScrapDetails_${currTs}.csv`);
        builder
            .setColumns(columns.map(columnDef => columnDef.headerName))
            .addRows(data)
            .exportFile();
    }

    return (
        <div style={{ width: "100%" }}>
            <Typography sx={styles.heading}>Possible Lost Assets</Typography>
            {isLoading ?
                <Stack alignItems="center">
                    <CircularProgress color="inherit" />
                </Stack> :
                <>
                    <Grid container>
                        <Grid item xs={3}>
                            <Box sx={{ width: "100%" }} mt={4} mb={4}>
                                <TextField
                                    value={props?.searchInput}
                                    onChange={(e) => {
                                        handleChange(e.target.value);
                                    }}
                                    autoComplete="off"
                                    sx={{
                                        borderRadius: "4px",
                                        input: {
                                            color: "#033F53",
                                        },
                                        width: "100%",
                                        background: "#fff",
                                        boxShadow: "0px 4px 8px rgba(16, 24, 64, 0.16)",
                                        "& .MuiInputBase-root.Mui-disabled": {
                                            background: "#E0E2EA",
                                            color: "#A6A6A6",
                                        },
                                    }}
                                    size={"small"}
                                    placeholder="Search"
                                    id="outlined-start-adornment"
                                    InputProps={{
                                        startAdornment:
                                            <InputAdornment position="start">
                                                <img src={SearchIcon} alt="" />
                                            </InputAdornment>
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={9}>
                            <Box mt={4} mb={4} display={"flex"} justifyContent={"end"}>
                                <Button
                                    onClick={handleLostScrapDownload}
                                    startIcon={<FileDownloadIcon />}
                                    variant="contained"
                                    style={{
                                        backgroundColor: "#3b62a1"
                                    }}
                                >
                                    Export Data
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                    {tableData && (
                        <DataGrid
                            rows={tableData}
                            columns={columns}
                            getRowId={(row) => row.rfid}
                            disableColumnMenu
                            autoHeight={true}
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            rowsPerPageOptions={[10, 20, 30, 40, 50]}
                            disableSelectionOnClick
                            hideFooterPagination={tableData.length > 0 ? false : true}
                            sx={{
                                ".MuiDataGrid-columnHeaders": {
                                    backgroundColor: "#FAFBFF",
                                },
                                '.MuiDataGrid-columnSeparator': {
                                    display: 'none',
                                },
                                '.MuiDataGrid-cell:focus': {
                                    outline: "none !important",
                                }
                            }}
                        />
                    )}
                </>
            }
        </div>
    );
};

export const styles = {
    heading: {
        color: "#303030",
        fontSize: "24px",
        fontWeight: 700,
    }
}

const mapStateToProps = (state) => {
    return {
        isReadOnlyUser: state.isReadOnlyUser,
        selectedCustomerListData: state.selectedCustomerListData,
        selectedLocationListData: state.selectedLocationListData,
        assetDetailsData: state.assetDetailsData,
        searchInput: state.searchInput
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAssetDetails: (userToken, customerId, locationId) => dispatch(LiftActions.ASSET_DETAILS_REQUEST_TYPE(userToken, customerId, locationId)),
        updateSearchInput: (searchInput) => dispatch(LiftActions.SEARCH_INPUT_UPDATE(searchInput))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LostScrapDetailsPage);